import { render, staticRenderFns } from "./ehc-item-icon.vue?vue&type=template&id=518740aa"
import script from "./ehc-item-icon.vue?vue&type=script&lang=js"
export * from "./ehc-item-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports